module.exports = __webpack_public_path__ + "static/logo-d469c730f46356d3a778ee5224b8618a.png";